export const PcRoutes = {
    Dashboard: "dashboard", //看板
    EvaAnal: "analysis", //评估分析
    ExecAnal: "achieving", //执行力分析
    BusInfo: "business", //商户信息
    BusConfig: "businessConfig", //商户配置
    Brand: "brand", //品牌管理
    Area: "areaEdit", //区域设置
    Dept: "department", //部门管理
    Store: "storeArchives", //门店档案管理
    StoreTag: "storeTags", //门店标签管理
    User: "user", //人员档案管理
    Role: "role", //角色管理
    Device: "device", //设备管理
    Assess: "task", //任务标准管理
    AssessTag: "taskTags", //任务标签管理
    TaskItem: "taskItem", //任务项管理
    TaskItemTag: "taskItemTags", //任务项标签管理
    TaskTpl: "taskTemplate", //任务模板
    RespLable: "responsibleLabel", //责任标签
    CorrectTpl: "correctTemplate", //整改模板
    CheckFlow: "checkflow", //审批流管理
    Market: "market", //市别设置
    Target: "target", //目标管理
    AnnMgmt: "publicNotice", //公告管理
    SchMgmt: "calendar", //日程管理
    AssignTask: "assignTask", //派发任务
    RoutResult: "routResultReport", //巡检结果报表
    RoutDetail: "routDetailReport", //巡检明细报表
    SelfResult: "selfResultReport", //自检结果报表
    SelfDetail: "selfDetailReport", //自检明细报表
    CustomTaskRpt: "customTaskReport", //自定义任务报表
    CorrectRpt: "correctReport", //整改报表
    CheckInRpt: "checkClockReport", //打卡签到报表
    UserPosRpt: "positioningReport", //人员轨迹报表
    WorkScoreRpt: "workScoreReport", //工分明细报表
    LicenseRpt: "licenseReport", //证照报表
    LogRpt: "logReport", //日志报表
    OptionRt: "optionRights", //功能权限
    DataRt: "dataRights", //数据权限
    EventRpt: "eventReport" //事件报表
}

const dbSubpagePath = 'dashboard/subpages'
export const DashboardSubpages = [{
    route: "correctOverdueDetail",
    menuId: "localMenu_0_1_1",
    label: "整改逾期明细",
    path: dbSubpagePath
},{
    route: "licenseExpiredDetail",
    menuId: "localMenu_0_1_2",
    label: "证照逾期明细",
    path: dbSubpagePath
},{
    route: "lowScoreInspectDetail",
    menuId: "localMenu_0_1_3",
    label: "巡检低分明细",
    path: dbSubpagePath
}]

export const EvaProblemRouter = {
    route: 'problem'
}

export const CorrectAnalRouter = {
    route: "correctAnal",
    menuId: "localMenu_0_4",
    label: "整改分析",
    type: 2,
    sort: 2.1
}

export const CourseRouter = {
    route: "course",
    menuId: "localMenu_1",
    menuIcon: "el-icon-data-board",
    label: "课程管理",
    type: 1,
    sort: 4.1,
    children: [{
        route: "course",
        menuId: "localMenu_1_1",
        label: "课程列表",
        type: 2,
        subpages: [{
            route: "courseType",
            menuId: "localMenu_1_1_1",
            label: "课程分类",
            rootLable: "课程管理"
        },
        {
            route: "resourceAssociated",
            menuId: "localMenu_1_1_2",
            label: "资源关联",
            rootLable: "课程管理"
        }]
    },{
        route: "courseResource",
        menuId: "localMenu_1_2",
        label: "课程资源",
        type: 2
    }]
}

export const ExecuteAssessmentTaskRouter = {
    path: '/executeTasks/executeAssessmentTask',
    name: 'executeAssessmentTask'
}

export const ReportRouter = {
    route: "report",
    menuId: "1281044370539221113",
    menuIcon: "el-icon-s-data",
    label: "报表查询",
    type: 1,
    sort: 7,
    children: [
        {
            route: "courseReport",
            menuId: "localMenu_2_1",
            label: "课程学习进度",
            type: 2,
            sort: 6.1
        },
        {
            route: "courseResourceReport",
            menuId: "localMenu_2_2",
            label: "课程资源学习进度",
            type: 2,
            sort: 6.2
        }
    ]
}

export const ArchiveCenterRoute = {
    route: "archiveCenter",
    menuId: "localMenu_2_3",
    label: "归档中心",
    type: 2,
    sort: 101,
    hidden: true
}

export const RespLableRoute = {
    route: PcRoutes.RespLable,
    menuId: "localMenu_3_1",
    label: "责任标签",
    type: 2,
    sort: 102,
    hidden: true
}

export const WorkScoreRoute = {
    menuId: "8",
    route: "workScore",
    children: [{
        "route": "workScoreType",
        "children": {
            "edit": true,
            "check": true
        },
        "menuId": "1",
        "label": "工分类型设置",
        "sort": 1,
        "type": 2,
    },
    {
        "route": "workScoreRegulation",
        "children": {
            "import": true,
            "edit": true,
            "check": true,
            "export": true
        },
        "menuId": "12",
        "label": "工分条例管理",
        "sort": 2,
        "type": 2,
    },
    {
        "route": "workScoreSystem",
        "children": {
            "import": true,
            "edit": true,
            "check": true,
            "export": true
        },
        "menuId": "2",
        "label": "工分制度管理",
        "sort": 2,
        "type": 2,
    },
    {
        "route": "workScoreRule",
        "children": {
            "add": true,
            "import": true,
            "edit": true,
            "del": true,
            "check": true,
            "export": true
        },
        "menuId": "3",
        "label": "工分规则管理",
        "sort": 3,
        "type": 2,
    }]
}